document.addEventListener('DOMContentLoaded', function () {
  const swiperEl = document.querySelector('swiper-container');

  if (swiperEl.swiper.el) {
    if (swiperEl.swiper.el.classList.contains('swiper-initialized')) {
      swiperEl.classList.add('swiper-initialized--custom');
    }
  }

  if (swiperEl && swiperEl.getAttribute('autoplay') === 'true') {
    swiperEl.addEventListener('mouseenter', () => {
      swiperEl.swiper.autoplay.stop();
    });

    swiperEl.addEventListener('mouseleave', () => {
      swiperEl.swiper.autoplay.start();
    });
  }
});
